import { Route } from "wouter";
import React, { Suspense, type ComponentType } from "react";
import { safeLazy as lazy } from "@/lib/safe-lazy";
import { MAINTENANCE_PAGES } from "./language";
const Maintenance=lazy(()=>import("./Maintenance"));
const MaintenancePaymentBridge=lazy(()=>import("@/components/branch-cash/MaintenancePaymentBridge"));
const Smallwares=lazy(()=>import("./Smallwares"));
const MaintenanceWithPayment=()=> <><Maintenance/><MaintenancePaymentBridge/></>;
// Insert before the catch-all in the application's existing Switch.
// Each route must be a direct Switch child; use this function's array, not a wrapping component.
export function maintenanceRoutes(PrivateRoute:ComponentType<{component:ComponentType}>){
   return [{path:"/maintenance",group:"Jobs"},{path:"/maintenance/dashboard",group:"Jobs"},...MAINTENANCE_PAGES].map(page=><Route key={page.path} path={page.path}><Suspense fallback={<div aria-busy="true" className="p-6"><div className="h-10 rounded bg-slate-200"/><div className="mt-3 h-64 rounded bg-slate-200"/></div>}><PrivateRoute component={page.group==="Smallwares"?Smallwares:MaintenanceWithPayment}/></Suspense></Route>);
}
